import _ from 'lodash';
import { SelectionAreaWrapper } from '@/shared/ui';
import EventPreviewStrip from '../eventPreviewStrip';
import { ID_DIV_STRIP_MANAGEMENT } from '../handler';
import useStripEvents from './useStripEvents';

/**
 * Renders the paged grid of strip-management event thumbnails inside a rubber-band selection area. Reads the current page slice, thumbnail sizing and selection state from useStripEvents, and marks each preview strip active when it matches the selected strip or selected when the drag selection includes its id.
 *
 * @returns The selection-area wrapper containing one preview strip per event on the page.
 */
const StripEvents = () => {
  const {
    selectionAreaWrapperRef,
    selectedStrip,
    eventStrips,
    isLoadingStrip,
    selectedMultipleStrip,
    sliceStrips,
    sizeThumbnailConfig,
    handleClickSelectEvent,
    setSelectedEvent,
  } = useStripEvents();

  return (
    <SelectionAreaWrapper
      ref={selectionAreaWrapperRef}
      id={ID_DIV_STRIP_MANAGEMENT}
      className="strips-container --min-width-strip-event"
      selectables=".single-strip-management-event"
      handleSetSelected={setSelectedEvent}
      defaultSelectedId={selectedStrip?.id as any}
      isNoData={eventStrips?.length === 0}
      isLoading={isLoadingStrip}
      couldForceReset
      isEmptySelected={_.isEmpty(selectedMultipleStrip)}
    >
      {(selected) => (
        <div className="strips-img-container">
          {_.map(sliceStrips, (strip, index) => (
            <EventPreviewStrip
              key={strip.id}
              index={index}
              id={`beat-${strip.id}`}
              isActive={strip.id === selectedStrip?.id}
              isSelected={selected.has(`beat-${strip.id}`)}
              event={strip}
              sizeThumbnailConfig={sizeThumbnailConfig}
              onClickSelectEvent={handleClickSelectEvent}
            />
          ))}
        </div>
      )}
    </SelectionAreaWrapper>
  );
};

export default StripEvents;
